/* iDOKNiT Paper Cone Add-On */

(() => {
  const getProductArea = (addon) =>
    addon.closest('product-info') ||
    addon.closest('.product') ||
    document;


  /* KEEP ORIGINAL WORKING WEIGHT LOGIC */
  const getSelectedWeightText = (addon) => {
    const productArea = getProductArea(addon);

    const selectedWeightPill = productArea.querySelector(
      '.idk-weight-buttons input[type="radio"]:checked'
    );

    if (selectedWeightPill) {
      return selectedWeightPill.value.trim();
    }

    const selectedWeightDropdown = productArea.querySelector(
      'select[name*="Weight" i] option:checked'
    );

    return selectedWeightDropdown
      ? selectedWeightDropdown.textContent.trim()
      : '';
  };


  const getSelectedWeight = (addon) => {
    const weightText = getSelectedWeightText(addon);

    const match = weightText.match(
      /(\d+(?:\.\d+)?)\s*g/i
    );

    return match ? Number(match[1]) : 0;
  };


  /* ONLY THIS PART IS UPDATED */
  const getSelectedColor = (addon) => {
    const productArea = getProductArea(addon);


    const containsColor = (element) => {
      const associatedLabel = element.id
        ? productArea.querySelector(
            `label[for="${CSS.escape(element.id)}"]`
          )
        : null;

      const fieldsetText =
        element.closest('fieldset')
          ?.querySelector('legend')
          ?.textContent || '';

      const surroundingText =
        element.closest('.product-form__input')
          ?.textContent || '';

      const searchableText = [
        element.name,
        element.id,
        element.getAttribute('aria-label'),
        element.getAttribute('data-option-name'),
        element.getAttribute('data-name'),
        associatedLabel?.textContent,
        fieldsetText,
        surroundingText
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

      return (
        searchableText.includes('color') ||
        searchableText.includes('colour')
      );
    };


    /* RADIO COLOR */
    const selectedColorRadio = Array.from(
      productArea.querySelectorAll(
        'input[type="radio"]:checked'
      )
    ).find(containsColor);

    if (selectedColorRadio) {
      return String(
        selectedColorRadio.value || ''
      ).trim();
    }


    /* DROPDOWN COLOR */
    const colorSelect = Array.from(
      productArea.querySelectorAll('select')
    ).find(containsColor);

    if (colorSelect) {
      const selectedOption =
        colorSelect.options[
          colorSelect.selectedIndex
        ];

      return String(
        selectedOption?.textContent ||
        selectedOption?.value ||
        colorSelect.value ||
        ''
      ).trim();
    }


    /*
      FALLBACK FOR SHOPIFY OPTION NAMES SUCH AS:
      Color
      COLOR
      Select Color
      Primary color
      SELECT PRIMARY COLOR
    */

    const optionControls = Array.from(
      productArea.querySelectorAll(
        'select, input[type="radio"]'
      )
    );

    for (const element of optionControls) {
      const name = String(
        element.name || ''
      ).toLowerCase();

      if (
        !name.includes('color') &&
        !name.includes('colour')
      ) {
        continue;
      }

      if (
        element.tagName === 'SELECT'
      ) {
        const selectedOption =
          element.options[
            element.selectedIndex
          ];

        return String(
          selectedOption?.textContent ||
          selectedOption?.value ||
          element.value ||
          ''
        ).trim();
      }

      if (
        element.type === 'radio'
      ) {
        const checked = Array.from(
          productArea.querySelectorAll(
            'input[type="radio"]:checked'
          )
        ).find(
          (radio) =>
            radio.name === element.name
        );

        if (checked) {
          return String(
            checked.value || ''
          ).trim();
        }
      }
    }


    return '';
  };


  const getYarnQuantity = (addon) => {
    const productArea = getProductArea(addon);

    const quantityInput =
      productArea.querySelector(
        'input[name="quantity"]'
      );

    const quantity =
      Number(
        quantityInput?.value || 1
      );

    return Number.isFinite(quantity) &&
      quantity > 0
      ? quantity
      : 1;
  };


  const getMaximumCones = (addon) => {
    const selectedWeight =
      getSelectedWeight(addon);

    const yarnQuantity =
      getYarnQuantity(addon);

    const totalWeight =
      selectedWeight *
      yarnQuantity;

    return Math.floor(
      totalWeight / 50
    );
  };


  const getConeQuantity = (addon) => {
    const quantity = Number(
      addon.dataset.coneQuantity || 0
    );

    return Number.isFinite(quantity) &&
      quantity >= 0
      ? quantity
      : 0;
  };


  const updateConeSelector = (addon) => {
    const minusButton =
      addon.querySelector(
        '[data-cone-minus]'
      );

    const plusButton =
      addon.querySelector(
        '[data-cone-plus]'
      );

    const quantityDisplay =
      addon.querySelector(
        '[data-cone-quantity]'
      );

    if (
      !minusButton ||
      !plusButton ||
      !quantityDisplay
    ) {
      return;
    }

    const maximumCones =
      getMaximumCones(addon);

    let coneQuantity =
      getConeQuantity(addon);

    if (
      coneQuantity >
      maximumCones
    ) {
      coneQuantity =
        maximumCones;
    }

    addon.dataset.coneQuantity =
      String(coneQuantity);

    addon.dataset.maximumCones =
      String(maximumCones);

    quantityDisplay.textContent =
      String(coneQuantity);

    minusButton.disabled =
      coneQuantity <= 0;

    plusButton.disabled =
      coneQuantity >= maximumCones;
  };


  const updateAllConeSelectors = () => {
    document
      .querySelectorAll(
        '[data-idk-cone-addon]'
      )
      .forEach(updateConeSelector);
  };


  const getYarnProperties = (form) => {
    const properties = {};

    const formData =
      new FormData(form);

    for (
      const [key, value]
      of formData.entries()
    ) {
      const match =
        key.match(
          /^properties\[(.+)\]$/
        );

      if (
        match &&
        value !== ''
      ) {
        properties[
          match[1]
        ] = value;
      }
    }

    return properties;
  };


  const setSubmitLoading = (
    form,
    loading
  ) => {
    const submitButton =
      form.querySelector(
        '[type="submit"]'
      );

    if (!submitButton) return;

    submitButton.disabled =
      loading;

    submitButton.setAttribute(
      'aria-disabled',
      String(loading)
    );

    submitButton.classList.toggle(
      'loading',
      loading
    );
  };


  const addYarnAndCones = async (
    event,
    addon,
    form
  ) => {
    event.preventDefault();
    event.stopImmediatePropagation();

    const coneQuantity =
      getConeQuantity(addon);

    if (coneQuantity <= 0) {
      form.dataset.idkConeBypass =
        'true';

      form.requestSubmit(
        event.submitter
      );

      return;
    }


    const yarnVariantInput =
      form.querySelector(
        '[name="id"]'
      );

    const yarnVariantId =
      Number(
        yarnVariantInput?.value
      );

    const coneVariantId =
      Number(
        addon.dataset.coneVariantId
      );

    const yarnQuantity =
      getYarnQuantity(addon);

    const selectedColor =
      getSelectedColor(addon);

    const productTitle =
      addon.dataset.productTitle ||
      document.title;

    const yarnProperties =
      getYarnProperties(form);


    if (
      !yarnVariantId ||
      !coneVariantId
    ) {
      console.error(
        'iDOKNiT cone add-on: missing variant ID.'
      );

      return;
    }


    const associationParts = [
      productTitle
    ];

    if (selectedColor) {
      associationParts.push(
        selectedColor
      );
    }


    const items = [
      {
        id: coneVariantId,
        quantity: coneQuantity,

        properties: {
          'For yarn':
            associationParts.join(
              ' | '
            )
        }
      },

      {
        id: yarnVariantId,
        quantity: yarnQuantity,
        properties: yarnProperties
      }
    ];


    const cart =
      document.querySelector(
        'cart-drawer'
      ) ||
      document.querySelector(
        'cart-notification'
      );


    const requestBody = {
      items
    };


    if (
      cart &&
      typeof cart
        .getSectionsToRender ===
        'function'
    ) {
      requestBody.sections =
        cart
          .getSectionsToRender()
          .map(
            (section) =>
              section.id
          );

      requestBody.sections_url =
        window.location.pathname;
    }


    try {
      setSubmitLoading(
        form,
        true
      );

      const root =
        window.Shopify?.routes
          ?.root || '/';


      const response =
        await fetch(
          `${root}cart/add.js`,
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body:
              JSON.stringify(
                requestBody
              )
          }
        );


      const result =
        await response.json();


      if (!response.ok) {
        throw new Error(
          result.description ||
          'Items could not be added.'
        );
      }


      addon.dataset.coneQuantity =
        '0';

      updateConeSelector(
        addon
      );


      if (
        cart &&
        typeof cart.renderContents ===
          'function' &&
        result.sections
      ) {
        cart.renderContents(
          result
        );
      } else {
        window.location.href =
          `${root}cart`;
      }


    } catch (error) {
      console.error(
        'iDOKNiT cone add-on:',
        error
      );

      alert(
        error.message ||
        'Items could not be added to the cart.'
      );

    } finally {
      setSubmitLoading(
        form,
        false
      );
    }
  };


  document.addEventListener(
    'click',
    (event) => {
      const plusButton =
        event.target.closest(
          '[data-cone-plus]'
        );

      const minusButton =
        event.target.closest(
          '[data-cone-minus]'
        );


      if (
        !plusButton &&
        !minusButton
      ) {
        if (
          event.target.closest(
            'quantity-input, .quantity'
          )
        ) {
          window.setTimeout(
            updateAllConeSelectors,
            50
          );
        }

        return;
      }


      const addon =
        event.target.closest(
          '[data-idk-cone-addon]'
        );

      if (!addon) return;


      let coneQuantity =
        getConeQuantity(addon);

      const maximumCones =
        getMaximumCones(addon);


      if (
        plusButton &&
        coneQuantity <
          maximumCones
      ) {
        coneQuantity += 1;
      }


      if (
        minusButton &&
        coneQuantity > 0
      ) {
        coneQuantity -= 1;
      }


      addon.dataset.coneQuantity =
        String(coneQuantity);

      updateConeSelector(
        addon
      );
    }
  );


  document.addEventListener(
    'submit',

    (event) => {
      const form =
        event.target;


      if (
        !(
          form instanceof
          HTMLFormElement
        )
      ) return;


      if (
        !form.matches(
          'form[action*="/cart/add"]'
        )
      ) return;


      if (
        form.dataset.idkConeBypass ===
          'true'
      ) {
        delete form.dataset
          .idkConeBypass;

        return;
      }


      const productArea =
        form.closest(
          'product-info'
        ) ||
        form.closest(
          '.product'
        ) ||
        document;


      const addon =
        productArea.querySelector(
          '[data-idk-cone-addon]'
        );


      if (!addon) return;


      addYarnAndCones(
        event,
        addon,
        form
      );
    },

    true
  );


  document.addEventListener(
    'change',
    () => {
      window.setTimeout(
        updateAllConeSelectors,
        50
      );
    }
  );


  document.addEventListener(
    'input',
    (event) => {
      if (
        event.target.matches(
          'input[name="quantity"]'
        )
      ) {
        updateAllConeSelectors();
      }
    }
  );


  document.addEventListener(
    'DOMContentLoaded',
    updateAllConeSelectors
  );


  updateAllConeSelectors();

})();